<template>
    <h1>Planowane wyłączenia - wszystkie</h1>
    <PlannedOutageReadonlySearchCriteria ref="plannedOutageAcceptSearchCriteria" v-model="searchCriteria"
                                         @update:modelValue="search"/>
    <PlannedOutageReadonlyTable ref="plannedOutageAcceptTable" :search-criteria="searchCriteria" />
</template>

<script>
    import {SearchCriteria} from "@/utils/SearchCriteria";
    import PlannedOutageReadonlyTable
        from "@/views/plannedOutrageReadonly/components/PlannedOutageReadonlyTable";
    import PlannedOutageReadonlySearchCriteria
        from "@/views/plannedOutrageReadonly/components/PlannedOutageReadonlySearchCriteria";

    export default {
        name: "PlannedOutageAllView",

        components: {
            PlannedOutageReadonlySearchCriteria,
            PlannedOutageReadonlyTable,
        },

        data() {
            return {
                searchCriteria: this.getClearSearchCriteria(),
            };
        },

        beforeMount() {
            SearchCriteria.loadCriteria(this);
        },

        methods: {
            search() {
                SearchCriteria.updateUrl(this);

                this.$refs.plannedOutageAcceptTable.search();
            },

            clear() {
                this.searchCriteria = this.getClearSearchCriteria();
            },

            getClearSearchCriteria() {
                return {
                    id: null,
                    addresses: {address: ""},
                    start: null,
                    end: null,
                    deleted: false,
                    page: {
                        limit: 10,
                        offset: 0,
                        sortField: null,
                        sortOrder: null,
                    },
                };
            },
        },
    };
</script>

<style lang="less" scoped>

</style>
